import { useRef, useState } from 'react';
import DatePicker from 'react-datepicker';

import { useClickOutside } from '../../../../hooks/useClickOutside';
import {
	ContainerFilterTime,
	ContainerShow,
	FilterTimeInput,
	FilterTimeLabel,
	ShowDatePickerContainer,
} from './styles';

interface DatePLPickerProps {
	date: Date;
	setDate: (date: Date) => void;
}

const DatePlPicker = ({ date, setDate }: DatePLPickerProps) => {
	const elementRef = useRef<HTMLDivElement>(null);

	const [showDatePicker, setShowDatePicker] = useState(false);
	const [startDate, setStartDate] = useState(date);

	const handleShowDatePicker = () => {
		setShowDatePicker(!showDatePicker);
	};

	const handleChangeDate = (date: Date) => {
		setDate(date);
		setStartDate(date);
		setShowDatePicker(false);
	};

	useClickOutside({ elementRef, callback: () => setShowDatePicker(false) });

	return (
		<ContainerFilterTime ref={elementRef}>
			<ContainerShow>
				<FilterTimeInput onClick={handleShowDatePicker}>
					{startDate.toLocaleDateString()}
				</FilterTimeInput>
			</ContainerShow>
			{showDatePicker && (
				<ShowDatePickerContainer y="bottom" x="right">
					<DatePicker
						locale="es"
						selected={startDate}
						onChange={(date) => handleChangeDate(date as Date)}
						maxDate={new Date()}
						inline
						customInput={<div></div>}
					/>
				</ShowDatePickerContainer>
			)}
		</ContainerFilterTime>
	);
};

export { DatePlPicker };
